import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the current space record whenever it is successfully updated (e.g.
 * general room information), since the update response doesn't include the
 * resulting history entry.
 */
export const reloadOnRecordUpdate = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(() =>
          collection.plugins.currentEntityPlugin.feature.actions.getEntity
            .from('(effect) reload on record update')
            .create({}),
        ),
      ),
)
